import { useForm as useFormHook } from "hooks";
import useValidationSchema from "./useValidationSchema";
import type { UboIdentity as IUboIdentity } from 'features/ecommerce/types';
import type {
    UboIdentity,
    OnboardingIdentityVerificationForm
} from "./types";
import { Identity } from "./entities";

export const getInitialValues = (
    initialValues: Partial<IUboIdentity>
): UboIdentity => new Identity(initialValues);

export const useForm = (onboardingIdentityVerification: OnboardingIdentityVerificationForm) =>
    useFormHook({
        isInitialValid: false,
        ...onboardingIdentityVerification,
        validateOnMount: true,
        validationSchema: useValidationSchema()
    });
